import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
    dismissedBanners: string[];
    theme: 'light' | 'dark';
}

const initialState: UiState = {
    dismissedBanners: [],
    theme: 'dark',   // dark is the default for new users
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        dismissBanner: (state, action: PayloadAction<string>) => {
            if (!state.dismissedBanners.includes(action.payload)) {
                state.dismissedBanners.push(action.payload);
            }
        },
        setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
            state.theme = action.payload;
        },
        toggleTheme: (state) => {
            state.theme = state.theme === 'light' ? 'dark' : 'light';
        },
    },
});

export const { dismissBanner, setTheme, toggleTheme } = uiSlice.actions;
export default uiSlice.reducer;
